import { Schema } from '../modules/account/_types/schema.types';
import { ApiLocalStorage } from './ApiLocalStorage';
import { SCHEMA_STORAGE_KEY } from '../modules/account/services/SchemaService';

/**
 * Função helper para buscar o schemaId do Local Storage
 * Pode ser usada em qualquer lugar, não apenas em hooks
 */
export const getSchemaIdFromStorage = (): string | null => {
  const schemaData: Schema | null = ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
  
  return schemaData?.id || null;
};

/**
 * Função helper para buscar o schema completo do Local Storage
 */
export const getSchemaFromStorage = (): Schema | null => ApiLocalStorage.get(SCHEMA_STORAGE_KEY);
